module.exports = __webpack_public_path__ + "img/zhichu.67cb41c1.png";